<template>
    <div class="section pt-2">
        <div class="grq-hero">
            <div class="grq-hero-icon"><ion-icon name="create-outline"></ion-icon></div>
            <h3 class="grq-hero-title mal-text">വിസ്ഡം ഗൈഡിൽ മാറ്റം വരുത്താനുള്ള / ചേർക്കാനുള്ള അപേക്ഷ</h3>
        </div>
    </div>

    <div class="section mt-1 mb-2">
        <div class="grq-card">
            <Form ref="reqForm" @submit="handleRegistration" :validation-schema="schema">
                <div class="grq-field-group">
                    <label class="grq-field-label mal-text">
                        ഈ അപേക്ഷ എന്തിന് വേണ്ടി ? <span class="text-danger">*</span>
                    </label>
                    <div class="grq-radio-group">
                        <label class="grq-radio-pill" :class="{ 'is-checked': formData.for_what == '1' }">
                            <input type="radio" :disabled="!permissions.edit" value="1" name="for_what" v-model="formData.for_what" />
                            <span class="mal-text">ഭരവഹിയെ മാറ്റാൻ</span>
                        </label>
                        <label class="grq-radio-pill" :class="{ 'is-checked': formData.for_what == '2' }">
                            <input type="radio" :disabled="!permissions.edit" value="2" name="for_what" v-model="formData.for_what" />
                            <span class="mal-text">വകുപ്പ് മാറ്റാൻ</span>
                        </label>
                        <label class="grq-radio-pill" :class="{ 'is-checked': formData.for_what == '3' }" v-if="formData.change_level == '4'">
                            <input type="radio" :disabled="!permissions.edit" value="3" name="for_what" v-model="formData.for_what" />
                            <span class="mal-text">മെമ്പർഷിപ്പ് ഒഴിവാക്കാൻ</span>
                        </label>
                        <label class="grq-radio-pill" :class="{ 'is-checked': formData.for_what == '4' }" v-if="formData.change_level == '4'">
                            <input type="radio" :disabled="!permissions.edit" value="4" name="for_what" v-model="formData.for_what" />
                            <span class="mal-text">പുതിയ മെമ്പർഷിപ് ചേർക്കാൻ</span>
                        </label>
                        <label class="grq-radio-pill" :class="{ 'is-checked': formData.for_what == '5' }">
                            <input type="radio" :disabled="!permissions.edit" value="5" name="for_what" v-model="formData.for_what" />
                            <span class="mal-text">മറ്റ് കാര്യങ്ങൾക്ക്</span>
                        </label>
                    </div>
                    <ErrorMessage name="for_what" class="error-feedback" />
                    <textarea v-if="formData.for_what == 5" :disabled="!permissions.edit" class="form-control mt-2" rows="4" name="for_what_other" v-model="formData.for_what_other" placeholder="വിശദമായി എഴുതുക"></textarea>
                    <ErrorMessage name="for_what_other" class="error-feedback" />
                </div>

                <div class="grq-field-group" v-if="formData.for_what == '1' || formData.for_what == '2' || formData.for_what == '3'">
                    <label class="grq-field-label mal-text">ഒഴിവാക്കേണ്ട ആൾ <span class="text-danger">*</span></label>
                    <v-select label="text" :disabled="!permissions.edit" class="mt-1" :filterable="true" v-model="member" :value="member" :options="member_list" @input="getTextList($event.target.value,'old')" @change="getDepartments(member.member.id,member.user_level)">
                        <template>Type to search...</template>
                        <template>
                            <div class="d-center">{{ member.name }}</div>
                        </template>
                    </v-select>
                    <ErrorMessage name="member" class="error-feedback" />
                </div>

                <div class="grq-field-group" v-if="formData.for_what == '2' && member">
                    <label class="grq-field-label mal-text">ഒഴിവാക്കേണ്ട വകുപ്പ് <span class="text-danger">*</span></label>
                    <div class="grq-checkbox-group">
                        <label class="grq-checkbox-pill" v-for="(item, index) in old_department_list" :key="item.department.id" :for="'ScustomCheckb' + (index + 1)">
                            <input :disabled="!permissions.edit" name="old_department[]" type="checkbox" :value="item.department.id" :id="'ScustomCheckb' + (index + 1)" v-model="formData.old_department" @change="changeOld" />
                            <span class="mal-text">{{ item.department.name_mal }}</span>
                        </label>
                    </div>
                    <ErrorMessage name="place" class="error-feedback" />
                </div>

                <div class="grq-field-group" v-if="formData.for_what == '1' && member">
                    <label class="grq-field-label mal-text">ഒഴിവാക്കേണ്ട സ്ഥാനം <span class="text-danger">*</span></label>
                    <div class="grq-checkbox-group">
                        <label class="grq-checkbox-pill" v-for="(item, index) in old_duty" :key="item.user_sublevel" :for="'SDcustomCheckb' + (index + 1)">
                            <input :disabled="!permissions.edit" name="old_duty[]" type="checkbox" :id="'SDcustomCheckb' + (index + 1)" :value="item.user_sublevel" v-model="formData.old_duty" @change="changeOld" />
                            <span class="mal-text">{{ item.name }}</span>
                        </label>
                    </div>
                    <ErrorMessage name="panjayath" class="error-feedback" />
                </div>

                <div class="grq-field-group">
                    <label class="grq-field-label mal-text">
                        എവിടെയാണ് മാറ്റം വരേണ്ടത് ? <span class="text-danger">*</span>
                    </label>
                    <div class="grq-radio-group">
                        <label class="grq-radio-pill" :class="{ 'is-checked': formData.change_level == '4' }" v-if="currentUser.user_level <= 4">
                            <input type="radio" value="4" name="change_level" v-model="formData.change_level" @change="changeUserLevel" />
                            <span class="mal-text">ശാഖാ [{{ profile.unit }}]</span>
                        </label>
                        <label class="grq-radio-pill" :class="{ 'is-checked': formData.change_level == '3' }" v-if="currentUser.user_level <= 3">
                            <input type="radio" value="3" name="change_level" v-model="formData.change_level" @change="changeUserLevel" />
                            <span class="mal-text">മണ്ഡലം [{{ profile.zone }}]</span>
                        </label>
                        <label class="grq-radio-pill" :class="{ 'is-checked': formData.change_level == '2' }" v-if="currentUser.user_level <= 2">
                            <input type="radio" value="2" name="change_level" v-model="formData.change_level" @change="changeUserLevel" />
                            <span class="mal-text">ജില്ല [{{ profile.district }}]</span>
                        </label>
                        <label class="grq-radio-pill" :class="{ 'is-checked': formData.change_level == '1' }" v-if="currentUser.user_level == 1">
                            <input type="radio" value="1" name="change_level" v-model="formData.change_level" @change="changeUserLevel" />
                            <span class="mal-text">സ്റ്റേറ്റ്</span>
                        </label>
                    </div>
                    <ErrorMessage name="change_level" class="error-feedback" />
                </div>

                <div class="grq-field-group">
                    <label class="grq-field-label mal-text">തീരുമാനിച്ച യോഗത്തിന്റെ തിയ്യതി <span class="text-danger">*</span></label>
                    <Field type="date" :disabled="!permissions.edit" class="form-control" name="meeting_date" v-model="formData.meeting_date" autocomplete="off" />
                    <ErrorMessage name="meeting_date" class="error-feedback" />
                </div>

                <div class="grq-field-group">
                    <label class="grq-field-label mal-text">തീരുമാനത്തിന്റെ ക്രമ നമ്പർ <span class="text-danger">*</span></label>
                    <Field type="text" :disabled="!permissions.edit" class="form-control" name="minutes_number" v-model="formData.minutes_number" placeholder="00" autocomplete="off" />
                    <ErrorMessage name="minutes_number" class="error-feedback" />
                </div>

                <div class="grq-field-group">
                    <label class="grq-field-label mal-text">തീരുമാനത്തിന്റെ ഫോട്ടോ ഇവിടെ ചേർക്കുക <span class="text-danger">*</span></label>
                    <div class="custom-file-upload mt-1" id="fileUpload1">
                        <input type="file" :disabled="!permissions.edit" id="fileuploadInput" @change="uploadImage($event)" />
                        <label for="fileuploadInput">
                            <span>
                                <strong>
                                    <ion-icon name="arrow-up-circle-outline"></ion-icon>
                                    <i>Upload</i>
                                </strong>
                            </span>
                        </label>
                        <label v-if="profile_image" for="fileuploadInput" class="file-uploaded" :style="{ 'background-image': 'url(' + profile_image + ')' }"></label>
                    </div>
                    <ErrorMessage name="shop_photo" class="error-feedback" />
                </div>

                <div class="grq-field-group" v-if="formData.for_what == '1' || formData.for_what == '2'">
                    <label class="grq-field-label mal-text">ഈ സ്ഥാനത്തേക്ക് പുതുതായി തിരഞ്ഞെടുത്ത ആൾ <span class="text-danger">*</span></label>
                    <v-select label="text" :disabled="!permissions.edit" class="mt-1" :filterable="true" v-model="new_member" :value="new_member" :options="new_member_list" @input="getTextList($event.target.value,'new')">
                        <template>Type to search...</template>
                        <template>
                            <div class="d-center">{{ new_member.name }}</div>
                        </template>
                    </v-select>
                    <ErrorMessage name="new_member" class="error-feedback" />
                </div>

                <div class="grq-field-group" v-if="formData.for_what == '2' && member">
                    <label class="grq-field-label mal-text">പുതിയ ആൾക്ക് നൽകേണ്ട വകുപ്പ് <span class="text-danger">*</span></label>
                    <div class="grq-checkbox-group">
                        <label class="grq-checkbox-pill" v-for="(item, index) in new_department_list" :key="item.department.id" :for="'SwcustomCheckb' + (index + 1)">
                            <input :disabled="!permissions.edit" name="new_department[]" type="checkbox" :value="item.department.id" :id="'SwcustomCheckb' + (index + 1)" v-model="formData.new_department" />
                            <span class="mal-text">{{ item.department.name_mal }}</span>
                        </label>
                    </div>
                    <ErrorMessage name="place" class="error-feedback" />
                </div>

                <div class="grq-field-group" v-if="formData.for_what == '1' && member">
                    <label class="grq-field-label mal-text">പുതിയ ആൾക്ക് നൽകേണ്ട സ്ഥാനം <span class="text-danger">*</span></label>
                    <div class="grq-checkbox-group">
                        <label class="grq-checkbox-pill" v-for="(item, index) in new_duty" :key="item.user_sublevel" :for="'SDNcustomCheckb' + (index + 1)">
                            <input :disabled="!permissions.edit" name="new_duty[]" type="checkbox" :id="'SDNcustomCheckb' + (index + 1)" :value="item.user_sublevel" v-model="formData.new_duty" />
                            <span class="mal-text">{{ item.name }}</span>
                        </label>
                    </div>
                    <ErrorMessage name="panjayath" class="error-feedback" />
                </div>

                <template v-if="formData.for_what == '4'">
                    <div class="grq-field-group">
                        <label class="grq-field-label" for="name">Name <span class="text-danger">*</span></label>
                        <Field name="name" type="text" class="form-control" id="name" v-model="formData.name" placeholder="Enter Name" autocomplete="off" />
                        <ErrorMessage name="name" class="error-feedback" />
                    </div>
                    <div class="row">
                        <div class="col-5">
                            <div class="grq-field-group">
                                <label class="grq-field-label" for="code">Code <span class="text-danger">*</span></label>
                                <Field as="select" class="form-control custom-select" id="code" name="code" v-model="formData.code">
                                    <option value="" :disabled="true" selected>#</option>
                                    <option v-for="code in country_code_list" :key="code.item_value" :value="code.item_value">{{ code.name }}</option>
                                </Field>
                                <ErrorMessage name="code" class="error-feedback" />
                            </div>
                        </div>
                        <div class="col-7">
                            <div class="grq-field-group">
                                <label class="grq-field-label" for="mobile">Mobile <span class="text-danger">*</span></label>
                                <Field type="number" class="form-control" id="mobile" name="mobile" placeholder="Mobile" v-model="formData.mobile"
                                    oninput="javascript: if (this.value.length > 10) this.value = this.value.slice(0, 10);" />
                                <ErrorMessage name="mobile" class="error-feedback" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-5">
                            <div class="grq-field-group">
                                <label class="grq-field-label" for="country_code_whatsapp">Code</label>
                                <Field as="select" class="form-control custom-select" id="country_code_whatsapp" name="country_code_whatsapp" v-model="formData.country_code_whatsapp">
                                    <option value="" :disabled="true" selected>#</option>
                                    <option v-for="code in country_code_list" :key="code.item_value" :value="code.item_value">{{ code.name }}</option>
                                </Field>
                                <ErrorMessage name="code" class="error-feedback" />
                            </div>
                        </div>
                        <div class="col-7">
                            <div class="grq-field-group">
                                <label class="grq-field-label" for="whatsapp">Whatsapp</label>
                                <Field type="number" class="form-control" id="whatsapp" name="whatsapp" placeholder="whatsapp" v-model="formData.whatsapp"
                                    oninput="javascript: if (this.value.length > 10) this.value = this.value.slice(0, 10);" />
                                <ErrorMessage name="whatsapp" class="error-feedback" />
                            </div>
                        </div>
                    </div>
                    <div class="grq-field-group">
                        <label class="grq-field-label" for="wing">Wing</label>
                        <Field as="select" class="form-control custom-select" v-model="formData.wing" name="wing" id="wing">
                            <option value>---Select---</option>
                            <option value="1">Wisdom</option>
                            <option value="2">Youth</option>
                            <option value="3">Students</option>
                            <option value="4">Women</option>
                            <option value="5">Balavedi</option>
                            <option value="6">Girls</option>
                        </Field>
                        <ErrorMessage name="wing" class="error-feedback" />
                    </div>
                </template>

                <button type="submit" class="btn btn-primary btn-block btn-lg mt-2" :disabled="loading" v-if="permissions.edit">
                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                    <span>Save</span>
                </button>
            </Form>
        </div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import {
    Form,
    Field,
    ErrorMessage
} from "vee-validate";
import * as yup from "yup";
import UserService from "../../services/user.service";
import $ from "jquery";
import vSelect from 'vue-select'
import AlertModel from "./../layouts/AlertModel.vue";
export default {
    name: "ExecutiveChangeRequest",
    props: {
        unit_id: null
    },
    components: {
        Form,
        Field,
        vSelect,
        ErrorMessage,
        AlertModel,
    },
    data() {
        const schema = yup.object().shape({
            meeting_date: yup.string().required("ഫിൽ ചെയ്യുക!"),
            minutes_number: yup.string().required("ഫിൽ ചെയ്യുക!"),
            name: yup.string().when('for_what', {
                is: value => value && value == 4,
                then: yup
                    .string()
                    .required("ഫിൽ ചെയ്യുക")
            }),
        });
        return {
            loading: false,
            schema,
            alert_type: "",
            alert_message: "",
            formData: {
                for_what: '',
                for_what_other: '',
                change_level: this.$route.params.sub_level,
                minutes_number: '',
                old_department: [],
                new_department: [],
                old_duty: [],
                new_duty: [],
                remarks: '',
                comments: '',
                name: '',
                code: '',
                mobile: '',
                whatsapp: '',
                country_code_whatsapp: '',
                wing: ''
            },
            editable_id: '',
            profile_image: null,
            profile_file: null,
            member_list: [],
            member: [],
            new_member_list: [],
            new_member: [],
            old_department_list: [],
            new_department_list: [],
            old_duty: [],
            new_duty: [],
            requestData: [],
            country_code_list: [],
            profile: [],
            permissions: {
                edit: true
            }
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
            return;
        }
        this.$root.updateParent("Request Form");
        this.getComboboxValues('COUNTRY_CODE');
        if (this.$route.params.request_id) {
            this.getRequest(this.$route.params.request_id);
        }
        this.profile = JSON.parse(localStorage.getItem("my_profile"));

        window.onpopstate = function() {
            if ($("body").hasClass("modal-open")) {
                location.reload();
            }
        };
    },
    watch: {
        // Vue Router reuses this same component instance when navigating between "New
        // Application" (/request) and "Edit" (/request/:request_id), or between two different
        // edit targets, since both match the same route — mounted() only runs once, so without
        // this the form kept showing whatever the PREVIOUS navigation had loaded until a full
        // page reload forced a remount.
        '$route.params.request_id'(newId) {
            this.resetFormForNewRequest();
            if (newId) {
                this.getRequest(newId);
            }
        },
    },
    methods: {
        // Restores the pristine "New Application" state — same shape as data()'s initial
        // formData — so switching (via SPA navigation, no full reload) from editing one request
        // to another, or from an edit back to a fresh "New Application", doesn't leave stale
        // data from whichever request was loaded previously in this same component instance.
        resetFormForNewRequest() {
            this.formData = {
                for_what: '',
                for_what_other: '',
                change_level: this.$route.params.sub_level,
                minutes_number: '',
                meeting_date: '',
                old_department: [],
                new_department: [],
                old_duty: [],
                new_duty: [],
                remarks: '',
                comments: '',
                name: '',
                code: '',
                mobile: '',
                whatsapp: '',
                country_code_whatsapp: '',
                wing: ''
            };
            this.editable_id = '';
            this.profile_image = null;
            this.profile_file = null;
            this.member_list = [];
            this.member = [];
            this.new_member_list = [];
            this.new_member = [];
            this.old_department_list = [];
            this.new_department_list = [];
            this.old_duty = [];
            this.new_duty = [];
            this.requestData = [];
            this.$nextTick(() => {
                if (this.$refs.reqForm) {
                    this.$refs.reqForm.resetForm();
                }
            });
        },
        changeOld() {
            // Pre-fill the "new" department/duty as a starting point only the first time —
            // the admin can then pick a genuinely different value; this must not keep
            // overwriting a selection they've already made.
            if (!this.formData.new_department.length) {
                this.formData.new_department = [...this.formData.old_department];
            }
            if (!this.formData.new_duty.length) {
                this.formData.new_duty = [...this.formData.old_duty];
            }
        },
        uploadImage(event) {
            var file = event.target.files[0];
            this.profile_file = file;
            this.profile_image = URL.createObjectURL(file);
        },
        getDepartments(member_id, user_level) {
            if (this.formData.for_what == '4' || this.formData.for_what == '3') {
                return 0;
            }
            let data = {
                member_id: member_id,
                user_level: user_level
            }
            UserService.authPostRequest('get-department-by-member', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.old_department_list = response.data.data.departments;
                        this.old_duty = response.data.data.duty;

                        this.new_department_list = response.data.data.departments;
                        this.new_duty = response.data.data.duty;
                    }
                }
            );
        },
        getTextList(event, textbox = null) {
            let type = '';
            if (textbox == 'old') {
                type = 'executive';
            } else {
                type = 'members';
                if (this.formData.for_what == '1') {
                    this.formData.old_duty.forEach(element => {
                        if (element <= 5) {
                            type = 'executive';
                            this.new_member_list = [];
                            this.new_member = [];
                        }
                    });
                    this.formData.old_duty.forEach(element => {
                        if (element == 6) {
                            type = 'members';
                            this.new_member_list = [];
                            this.new_member = [];
                        }
                    });
                } else if (this.formData.for_what == '2') {
                    type = 'executive';
                }
            }

            if (this.formData.for_what == '3') {
                type = 'members';
            }
            let user_level = this.formData.change_level;
            let user_level_id = 0;
            if (user_level == 1) {
                user_level_id = 0;
            } else if (user_level == 2) {
                user_level_id = this.currentUser.district_id;
            } else if (user_level == 3) {
                user_level_id = this.currentUser.zone_id;
            } else if (user_level == 4) {
                user_level_id = this.currentUser.unit_id;
            }

            let data = {
                q: event,
                type: type,
                filter: 'inside',
                user_level_id: user_level_id,
                user_level: user_level,
                wing: this.currentUser.wing,
            }
            UserService.authPostRequest('get-members-executives-by-id', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        if (textbox == 'old') {
                            this.member_list = response.data.data.list;
                        } else {
                            this.new_member_list = response.data.data.list;
                        }
                    }
                }
            );
        },
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id,
            };
            UserService.getCombobox(data).then(
                (response) => {
                    if (code === "COUNTRY_CODE") {
                        this.country_code_list = response.data.data.list.options;
                    }
                }
            );
        },
        handleRegistration() {
            if (!this.formData.for_what) {
                this.alert_type = "Warning";
                this.alert_message = 'അപേക്ഷ എന്തിനു വേണ്ടി എന്ന് സെലക്ട് ചെയ്യുക';
                this.$refs.alert_model.openModel();
                return false;
            }
            if (!this.profile_file && !this.profile_image) {
                // profile_file is only set when a NEW file is picked this session — when
                // editing a request that already has a photo, it's loaded as profile_image (a
                // URL) instead, with no reason to force re-uploading an unchanged photo.
                this.alert_type = "Warning";
                this.alert_message = 'തീരുമാനത്തിന്റെ ഫോട്ടോ അപ്‌ലോഡ് ചെയ്യുക';
                this.$refs.alert_model.openModel();
                return false;
            }
            if ((this.formData.for_what == "1" || this.formData.for_what == "2" || this.formData.for_what == "3")) {
                if (!this.member.member_id) {
                    this.alert_type = "Warning";
                    this.alert_message = 'ഒഴിവാക്കേണ്ട ആളെ സെലക്ട് ചെയ്യുക';
                    this.$refs.alert_model.openModel();
                    return false;
                }
            }
            if ((this.formData.for_what == "1" || this.formData.for_what == "2")) {
                if (!this.new_member.member_id) {
                    this.alert_type = "Warning";
                    this.alert_message = 'പുതുതായി ചേർക്കേണ്ട ആളെ സെലക്ട് ചെയ്യുക';
                    this.$refs.alert_model.openModel();
                    return false;
                }
                if (!this.formData.old_duty.length && this.formData.for_what == "1") {
                    this.alert_type = "Warning";
                    this.alert_message = 'ഒഴിവാക്കേണ്ട സ്ഥാനം സെലക്ട് ചെയ്യുക';
                    this.$refs.alert_model.openModel();
                    return false;
                }
                if (!this.formData.new_duty.length && this.formData.for_what == "1") {
                    this.alert_type = "Warning";
                    this.alert_message = 'പുതുതായി ചേർക്കേണ്ട സ്ഥാനം സെലക്ട് ചെയ്യുക';
                    this.$refs.alert_model.openModel();
                    return false;
                }
                if (!this.formData.old_department.length && this.formData.for_what == "2") {
                    this.alert_type = "Warning";
                    this.alert_message = 'ഒഴിവാക്കേണ്ട വകുപ്പുകൾ സെലക്ട് ചെയ്യുക';
                    this.$refs.alert_model.openModel();
                    return false;
                }
                if (!this.formData.new_department.length && this.formData.for_what == "2") {
                    this.alert_type = "Warning";
                    this.alert_message = 'പുതുതായി ചേർക്കേണ്ട വകുപ്പുകൾ സെലക്ട് ചെയ്യുക';
                    this.$refs.alert_model.openModel();
                    return false;
                }
            }
            this.loading = true;
            const formData_ = new FormData();
            if (this.profile_file) {
                formData_.append('minutes_image', this.profile_file);
            }
            if (this.editable_id) {
                formData_.append('editable_id', this.editable_id);
            }

            let user_level = this.formData.change_level;
            let user_level_id = 0;
            if (user_level == 1) {
                user_level_id = 0;
            } else if (user_level == 2) {
                user_level_id = this.currentUser.district_id;
            } else if (user_level == 3) {
                user_level_id = this.currentUser.zone_id;
            } else if (user_level == 4) {
                user_level_id = this.currentUser.unit_id;
            }

            formData_.append('user_level', user_level);
            formData_.append('user_level_id', user_level_id);
            formData_.append('for_what', this.formData.for_what);
            formData_.append('for_what_other', this.formData.for_what_other);
            formData_.append('meeting_date', this.formData.meeting_date);
            formData_.append('minutes_number', this.formData.minutes_number);
            formData_.append('member', this.member.member_id);
            formData_.append('old_department', JSON.stringify(this.formData.old_department));
            formData_.append('old_duty', JSON.stringify(this.formData.old_duty));
            formData_.append('new_member', this.new_member.member_id);
            formData_.append('new_department', JSON.stringify(this.formData.new_department));
            formData_.append('new_duty', JSON.stringify(this.formData.new_duty));
            formData_.append('remarks', this.formData.remarks);
            formData_.append('comments', this.formData.comments);

            formData_.append('name', this.formData.name);
            formData_.append('country_code', this.formData.code);
            formData_.append('mobile', this.formData.mobile);
            formData_.append('country_code_whatsapp', this.formData.country_code_whatsapp);
            formData_.append('whatsapp', this.formData.whatsapp);
            formData_.append('wing', this.formData.wing);

            UserService.authPostRequest("store-request", formData_).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status == "success") {
                        this.alert_type = "Success";
                        this.alert_message = response.data.message || 'അപേക്ഷ സേവ് ചെയ്തു.';
                        this.$refs.alert_model.openModel();
                        const savedId = (response.data.data && response.data.data.id) || this.editable_id;
                        setTimeout(() => {
                            if (savedId) {
                                this.$router.push(
                                    '/org/' + this.$route.params.sub_level + '/' + this.$route.params.id
                                    + '/request-view/' + savedId
                                );
                            } else {
                                this.$router.push(
                                    '/org/' + this.$route.params.sub_level + '/' + this.$route.params.id + '/request-list'
                                );
                            }
                        }, 1500);
                    } else {
                        this.alert_type = response.data.status === "warning" ? "Warning" : "Error";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = "Error";
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        changeUserLevel() {
            this.formData.old_department = [];
            this.formData.new_department = [];
            this.formData.old_duty = [];
            this.formData.new_duty = [];
            this.member = [];
            this.new_member = [];

            this.new_department_list = [];
            this.old_department_list = [];
            this.new_duty = [];
            this.old_duty = [];

            this.member_list = [];
            this.new_member_list = [];
        },
        getRequest(id) {
            UserService.authPostRequest('get-request', { id }).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.requestData = response.data.data.list;
                        this.permissions = response.data.data.permissions;
                        // request_sub_type/meeting_date/minutes_number arrive as their raw JSON
                        // types (a number for sub_type) — the "for_what" radios compare via
                        // native v-model against a string `value="1"` attribute, so a numeric 1
                        // never matches and shows unchecked even though the data is "the same".
                        // Also push the vee-validate-tracked fields through the Form's own
                        // setValues() rather than relying solely on plain formData mutation,
                        // since Field components don't reliably pick up a late external update
                        // to their v-model source otherwise.
                        this.formData.for_what = String(this.requestData.request_sub_type);
                        this.formData.meeting_date = this.requestData.meeting_date || '';
                        this.formData.minutes_number = this.requestData.minutes_number || '';
                        // change_level must reflect where THIS REQUEST actually originated
                        // (requestData.user_level) — it was previously left at whatever
                        // change_level had defaulted to from the current URL's sub_level (the
                        // viewer's own browsing context), which is unrelated and wrong once
                        // someone other than the original creator opens this to edit it.
                        if (this.requestData.user_level) {
                            this.formData.change_level = String(this.requestData.user_level);
                        }
                        this.$nextTick(() => {
                            if (this.$refs.reqForm) {
                                this.$refs.reqForm.setValues({
                                    for_what: this.formData.for_what,
                                    meeting_date: this.formData.meeting_date,
                                    minutes_number: this.formData.minutes_number,
                                });
                            }
                        });
                        if (this.requestData.minutes_image) {
                            this.profile_image = 'https://guide.msoftit.com/' + this.requestData.minutes_image;
                        }
                        if (this.requestData.member_to_change) {
                            this.member = {
                                id: this.requestData.member_to_change.member_id,
                                member_id: this.requestData.member_to_change.member_id,
                                text: this.requestData.member_to_change.member.name,
                                mobile: this.requestData.member_to_change.member.mobile,
                                country_code: this.requestData.member_to_change.member.country_code
                            }
                            this.member_list.push(this.member);
                        }
                        if ((this.formData.for_what == '1' || this.formData.for_what == '2') && this.requestData.member_to_change) {
                            this.getDepartments(this.requestData.member_to_change.member_id, this.requestData.user_level);
                        }

                        if (this.requestData.new_member_to_change) {
                            this.new_member = {
                                id: this.requestData.new_member_to_change.member_id,
                                member_id: this.requestData.new_member_to_change.member_id,
                                text: this.requestData.new_member_to_change.member.name,
                                mobile: this.requestData.new_member_to_change.member.mobile,
                                country_code: this.requestData.new_member_to_change.member.country_code
                            }
                            this.new_member_list.push(this.new_member);
                        }

                        this.editable_id = this.requestData.id;
                        if (this.requestData.departments_to_change) {
                            this.formData.old_department = JSON.parse(this.requestData.departments_to_change);
                        }
                        if (this.requestData.new_departments_to_change) {
                            this.formData.new_department = JSON.parse(this.requestData.new_departments_to_change);
                        }
                        if (this.requestData.designations_to_change) {
                            this.formData.old_duty = JSON.parse(this.requestData.designations_to_change);
                        }
                        if (this.requestData.new_designations_to_change) {
                            this.formData.new_duty = JSON.parse(this.requestData.new_designations_to_change);
                        }
                    }
                }
            );
        },
    },
};
</script>

<style scoped>
.grq-hero {
    background: #fff;
    border-radius: 14px;
    padding: 20px 18px;
    text-align: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.grq-hero-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #eef2ff;
    color: #1a418c;
    font-size: 24px;
    margin-bottom: 8px;
}

.grq-hero-title {
    font-size: 1rem;
    font-weight: 700;
    color: #27173E;
    margin: 0;
}

.grq-card {
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.grq-field-group {
    margin-bottom: 16px;
}

.grq-field-label {
    display: block;
    font-size: 0.85rem;
    font-weight: 700;
    color: #1a418c;
    margin-bottom: 8px;
}

.grq-radio-group,
.grq-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.grq-radio-pill,
.grq-checkbox-pill {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border-radius: 20px;
    border: 1.5px solid #dbe3ff;
    background: #f8f9fc;
    font-size: 0.82rem;
    font-weight: 600;
    color: #27173E;
    cursor: pointer;
    transition: border-color 0.15s ease, background 0.15s ease;
}

.grq-radio-pill input,
.grq-checkbox-pill input {
    margin: 0;
}

.grq-radio-pill.is-checked {
    border-color: #1a418c;
    background: #eef2ff;
    color: #1a418c;
}

.error-feedback {
    color: red;
    font-size: 0.78rem;
}

.custom-file-upload {
    position: relative;
    display: flex;
    width: 50%;
    height: 100px;
}

.form-check-input:disabled~.form-check-label,
.form-check-input[disabled]~.form-check-label {
    opacity: 1;
    color: #060606;
}
</style>
